import React, { useState, useEffect, useCallback, useMemo } from 'react';

async function apiFetch(url, options = {}) {
  const token = localStorage.getItem('bizsuite_token');
  const headers = { ...(options.headers || {}) };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (!options.headers?.['Content-Type'] && !(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }
  const res = await fetch(url, { ...options, headers, credentials: 'include' });
  if (res.status === 401) {
    localStorage.removeItem('bizsuite_token');
    window.location.href = '/login.html';
    throw new Error('Unauthorized');
  }
  return res;
}

const S = {
  container: { padding: '24px 0' },

  topBar: {
    display: 'grid', gridTemplateColumns: '1.5fr 2.5fr auto', gap: 12,
    marginBottom: 12, alignItems: 'flex-end',
  },
  field: { display: 'flex', flexDirection: 'column', gap: 4 },
  label: { fontSize: 11, fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: 0.5 },
  input: {
    padding: '8px 10px', fontSize: 13, background: 'rgba(15,23,42,0.6)',
    border: '1px solid rgba(255,255,255,0.08)', borderRadius: 6, color: '#E2E8F0',
    boxSizing: 'border-box', width: '100%',
  },
  select: {
    padding: '7px 9px', fontSize: 12.5, background: 'rgba(15,23,42,0.6)',
    border: '1px solid rgba(255,255,255,0.08)', borderRadius: 6, color: '#E2E8F0',
    width: '100%',
  },
  saveBtn: {
    padding: '9px 18px', background: 'rgba(59,130,246,0.7)',
    border: '1px solid rgba(59,130,246,0.9)', color: '#fff',
    borderRadius: 6, fontWeight: 700, fontSize: 13, cursor: 'pointer',
  },
  ghostBtn: {
    padding: '9px 18px', background: 'rgba(100,116,139,0.4)',
    border: '1px solid rgba(100,116,139,0.7)', color: '#fff',
    borderRadius: 6, fontWeight: 600, fontSize: 13, cursor: 'pointer',
  },

  card: {
    background: 'rgba(30,41,59,0.7)',
    border: '1px solid rgba(255,255,255,0.06)', borderRadius: 12,
    padding: 16, marginBottom: 14,
  },
  sectionTitle: {
    fontSize: 12, fontWeight: 700, color: '#CBD5E1',
    textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 10,
  },

  primaryRow: {
    display: 'grid', gridTemplateColumns: '120px 2fr 1fr', gap: 10,
    alignItems: 'center', marginBottom: 12,
  },

  joinRow: {
    display: 'grid',
    gridTemplateColumns: '90px 1.4fr 0.8fr 1.2fr auto 1.2fr 30px',
    gap: 8, alignItems: 'center', marginTop: 8,
    padding: '10px 8px', borderRadius: 8,
    background: 'rgba(15,23,42,0.4)', border: '1px solid rgba(255,255,255,0.05)',
  },
  joinLabel: { fontSize: 11, color: '#94A3B8', textAlign: 'center' },
  removeJoinBtn: {
    background: 'transparent', border: '1px solid rgba(239,68,68,0.4)',
    color: '#FCA5A5', borderRadius: 5, padding: '4px 8px',
    cursor: 'pointer', fontSize: 13, lineHeight: 1,
  },
  addJoinBtn: {
    marginTop: 10, padding: '8px 14px',
    background: 'rgba(34,197,94,0.15)', border: '1px dashed rgba(34,197,94,0.5)',
    color: '#86EFAC', borderRadius: 6, cursor: 'pointer', fontSize: 12.5,
  },

  hint: { fontSize: 11, color: '#64748B', marginTop: 4 },

  errorBanner: {
    background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.4)',
    color: '#FCA5A5', padding: '10px 14px', borderRadius: 6, marginBottom: 12, fontSize: 13,
  },
  successBanner: {
    background: 'rgba(16,185,129,0.15)', border: '1px solid rgba(16,185,129,0.4)',
    color: '#6EE7B7', padding: '10px 14px', borderRadius: 6, marginBottom: 12, fontSize: 13,
  },

  previewCard: {
    background: 'rgba(15,23,42,0.6)', border: '1px solid rgba(255,255,255,0.06)',
    borderRadius: 8, marginTop: 12, overflow: 'hidden',
  },
  previewHeader: {
    padding: '8px 12px', background: 'rgba(15,23,42,0.8)',
    fontSize: 11, fontWeight: 700, color: '#94A3B8',
    textTransform: 'uppercase', letterSpacing: 0.5,
  },
  previewTable: { width: '100%', fontSize: 11, borderCollapse: 'collapse' },
  previewTh: {
    padding: '6px 10px', textAlign: 'left',
    color: '#CBD5E1', borderBottom: '1px solid rgba(255,255,255,0.06)',
    background: 'rgba(15,23,42,0.4)', whiteSpace: 'nowrap', fontSize: 10.5,
  },
  previewTd: {
    padding: '5px 10px', borderBottom: '1px solid rgba(255,255,255,0.03)',
    color: '#E2E8F0', whiteSpace: 'nowrap', maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis',
  },

  // Saved sources
  savedHeader: {
    display: 'grid', gridTemplateColumns: '1.6fr 2fr 1fr 200px',
    padding: '8px 12px', fontSize: 11, fontWeight: 700, color: '#94A3B8',
    textTransform: 'uppercase', letterSpacing: 0.5,
  },
  savedRow: {
    display: 'grid', gridTemplateColumns: '1.6fr 2fr 1fr 200px',
    padding: '10px 12px', alignItems: 'center', fontSize: 13,
    borderTop: '1px solid rgba(255,255,255,0.04)',
  },
  iconBtn: {
    background: 'transparent', border: '1px solid rgba(255,255,255,0.1)', color: '#94A3B8',
    padding: '4px 10px', borderRadius: 5, cursor: 'pointer', fontSize: 11, marginLeft: 4,
  },
};

const SAFE_ID_RE = /^[a-zA-Z_][a-zA-Z0-9_]*$/;

function aliasFor(tableName, takenAliases) {
  const base = String(tableName || '').replace(/[^a-z]/gi, '').slice(0, 4).toLowerCase() || 't';
  let alias = base;
  let n = 1;
  while (takenAliases.has(alias)) { alias = `${base}${n++}`; }
  return alias;
}

export default function JoinedSources() {
  const [standardTables, setStandardTables] = useState([]);
  const [customTables, setCustomTables] = useState([]);
  const [savedSources, setSavedSources] = useState([]);

  const [editingId, setEditingId] = useState(null);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [primaryTable, setPrimaryTable] = useState('');
  const [primaryAlias, setPrimaryAlias] = useState('');
  const [joins, setJoins] = useState([]); // [{ table, alias, join_type, left_alias, left_field, right_field }]

  // Per-table column cache: { [tableName]: [{name,type,label}, ...] }
  const [columnCache, setColumnCache] = useState({});

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [saving, setSaving] = useState(false);
  const [previewing, setPreviewing] = useState(false);
  const [preview, setPreview] = useState(null); // { columns, sample_rows }

  const loadTables = useCallback(async () => {
    try {
      const r = await apiFetch('/api/admin/joined-sources/_tables');
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Failed to load tables');
      setStandardTables(d.standard || []);
      setCustomTables(d.custom || []);
    } catch (e) { setError(e.message); }
  }, []);

  const loadSaved = useCallback(async () => {
    try {
      const r = await apiFetch('/api/admin/joined-sources');
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Failed to load saved sources');
      setSavedSources(d.sources || []);
    } catch (e) { setError(e.message); }
  }, []);

  useEffect(() => { loadTables(); loadSaved(); }, [loadTables, loadSaved]);

  // Lazy-fetch column list for a table
  const fetchCols = useCallback(async (tableName) => {
    if (!tableName) return [];
    if (columnCache[tableName]) return columnCache[tableName];
    try {
      const r = await apiFetch(`/api/admin/joined-sources/_columns/${encodeURIComponent(tableName)}`);
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Failed to load columns');
      setColumnCache((c) => ({ ...c, [tableName]: d.columns || [] }));
      return d.columns || [];
    } catch (e) {
      setError(e.message);
      return [];
    }
  }, [columnCache]);

  // Pre-fetch columns for any table referenced in current state
  useEffect(() => {
    const tables = new Set();
    if (primaryTable) tables.add(primaryTable);
    joins.forEach((j) => { if (j.table) tables.add(j.table); });
    tables.forEach((t) => {
      if (!columnCache[t]) fetchCols(t);
    });
  }, [primaryTable, joins, fetchCols, columnCache]);

  // Derived: alias → table mapping (for showing left-side picker)
  const aliasMap = useMemo(() => {
    const m = {};
    if (primaryAlias && primaryTable) m[primaryAlias] = primaryTable;
    joins.forEach((j) => { if (j.alias && j.table) m[j.alias] = j.table; });
    return m;
  }, [primaryAlias, primaryTable, joins]);

  const takenAliases = useMemo(() => {
    const s = new Set();
    if (primaryAlias) s.add(primaryAlias);
    joins.forEach((j) => { if (j.alias) s.add(j.alias); });
    return s;
  }, [primaryAlias, joins]);

  const reset = () => {
    setEditingId(null);
    setName(''); setDescription('');
    setPrimaryTable(''); setPrimaryAlias('');
    setJoins([]);
    setError(null); setSuccess(null); setPreview(null);
  };

  const onPickPrimary = (table) => {
    setPrimaryTable(table);
    if (table && !primaryAlias) {
      setPrimaryAlias(aliasFor(table, new Set()));
    }
  };

  const addJoin = () => {
    setJoins((prev) => prev.concat([{
      table: '',
      alias: '',
      join_type: 'left',
      left_alias: primaryAlias || (prev.length ? prev[prev.length - 1].alias : ''),
      left_field: '',
      right_field: '',
    }]));
  };

  const updateJoin = (idx, patch) => {
    setJoins((prev) => prev.map((j, i) => {
      if (i !== idx) return j;
      const next = { ...j, ...patch };
      // Auto-suggest alias when table changes
      if (patch.table && !j.alias) {
        next.alias = aliasFor(patch.table, takenAliases);
      }
      return next;
    }));
  };

  const removeJoin = (idx) => {
    setJoins((prev) => prev.filter((_, i) => i !== idx));
  };

  const buildDefinition = () => ({
    primary_table: primaryTable,
    primary_alias: primaryAlias,
    joins: joins.map((j) => ({
      table: j.table,
      alias: j.alias,
      join_type: j.join_type || 'left',
      left_alias: j.left_alias,
      left_field: j.left_field,
      right_field: j.right_field,
    })),
  });

  const validate = () => {
    if (!name.trim()) return 'Name is required';
    if (!SAFE_ID_RE.test(name.trim())) return 'Name must start with a letter and use only letters/numbers/underscores';
    if (!primaryTable) return 'Pick a primary table';
    if (!primaryAlias || !SAFE_ID_RE.test(primaryAlias)) return 'Primary alias is invalid';
    if (!joins.length) return 'Add at least one joined table (otherwise this is just a single table)';
    for (let i = 0; i < joins.length; i++) {
      const j = joins[i];
      if (!j.table) return `Join #${i + 1}: pick a table`;
      if (!j.alias || !SAFE_ID_RE.test(j.alias)) return `Join #${i + 1}: alias is invalid`;
      if (!j.left_alias) return `Join #${i + 1}: pick the left side alias`;
      if (!j.left_field) return `Join #${i + 1}: pick the left field`;
      if (!j.right_field) return `Join #${i + 1}: pick the right field`;
    }
    return null;
  };

  const onPreview = async () => {
    setError(null); setSuccess(null); setPreview(null);
    const v = validate();
    if (v) return setError(v);
    setPreviewing(true);
    try {
      const r = await apiFetch('/api/admin/joined-sources/preview', {
        method: 'POST',
        body: JSON.stringify({ definition: buildDefinition() }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Preview failed');
      setPreview(d);
    } catch (e) {
      setError(e.message);
    } finally {
      setPreviewing(false);
    }
  };

  const onSave = async () => {
    setError(null); setSuccess(null);
    const v = validate();
    if (v) return setError(v);
    setSaving(true);
    try {
      const body = {
        name: name.trim(),
        description: description || '',
        definition: buildDefinition(),
      };
      const url = editingId
        ? `/api/admin/joined-sources/${editingId}`
        : '/api/admin/joined-sources';
      const method = editingId ? 'PUT' : 'POST';
      const r = await apiFetch(url, { method, body: JSON.stringify(body) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Save failed');
      setSuccess(editingId ? 'Joined source updated' : 'Joined source saved');
      loadSaved();
      if (!editingId) reset();
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  };

  const onLoad = async (s) => {
    setEditingId(s.id);
    setName(s.name);
    setDescription(s.description || '');
    setPrimaryTable(s.definition.primary_table || '');
    setPrimaryAlias(s.definition.primary_alias || '');
    setJoins((s.definition.joins || []).map((j) => ({ ...j })));
    setError(null); setSuccess(null); setPreview(null);
  };

  const onDelete = async (s) => {
    if (!confirm(`Delete joined source "${s.name}"?`)) return;
    try {
      const r = await apiFetch(`/api/admin/joined-sources/${s.id}`, { method: 'DELETE' });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Delete failed');
      if (editingId === s.id) reset();
      loadSaved();
    } catch (e) { setError(e.message); }
  };

  const allPickerTables = useMemo(() => ([
    ...standardTables.map((t) => ({ value: t, label: t, group: 'Standard' })),
    ...customTables.map((t) => ({ value: t.table_name, label: t.display_name, group: 'Custom' })),
  ]), [standardTables, customTables]);

  return (
    <div style={S.container}>
      <div style={S.topBar}>
        <div style={S.field}>
          <label style={S.label}>Joined Source Name {editingId && <span style={{ color: '#FCD34D', marginLeft: 4 }}>(editing)</span>}</label>
          <input
            type="text"
            style={S.input}
            value={name}
            onChange={(e) => { setName(e.target.value); setError(null); }}
            placeholder="e.g. allocation_with_leave"
          />
        </div>
        <div style={S.field}>
          <label style={S.label}>Description</label>
          <input
            type="text"
            style={S.input}
            value={description}
            onChange={(e) => { setDescription(e.target.value); setError(null); }}
            placeholder="Allocations + employees + leave plans"
          />
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          {editingId && <button style={S.ghostBtn} onClick={reset}>New</button>}
          <button style={S.ghostBtn} onClick={onPreview} disabled={previewing}>
            {previewing ? 'Previewing...' : 'Preview'}
          </button>
          <button style={S.saveBtn} onClick={onSave} disabled={saving}>
            {saving ? 'Saving...' : (editingId ? 'Update' : 'Save')}
          </button>
        </div>
      </div>

      {error && <div style={S.errorBanner}>{error}</div>}
      {success && <div style={S.successBanner}>{success}</div>}

      {/* ── Primary table ───────────────────────────────────── */}
      <div style={S.card}>
        <div style={S.sectionTitle}>Primary Table</div>
        <div style={S.primaryRow}>
          <span style={{ fontSize: 12, color: '#94A3B8' }}>FROM</span>
          <select style={S.select} value={primaryTable} onChange={(e) => onPickPrimary(e.target.value)}>
            <option value="">Select primary table…</option>
            <optgroup label="Standard">
              {standardTables.map((t) => <option key={t} value={t}>{t}</option>)}
            </optgroup>
            <optgroup label="Custom">
              {customTables.map((t) => <option key={t.table_name} value={t.table_name}>{t.display_name}</option>)}
            </optgroup>
          </select>
          <input
            type="text"
            style={S.input}
            value={primaryAlias}
            onChange={(e) => setPrimaryAlias(e.target.value.replace(/[^a-zA-Z0-9_]/g, ''))}
            placeholder="alias (e.g. a)"
          />
        </div>

        <div style={S.sectionTitle}>Joined Tables</div>
        {joins.length === 0 && (
          <div style={{ ...S.hint, padding: 8 }}>No joins yet. Click "+ Add Join" to bring in another table.</div>
        )}
        {joins.map((j, idx) => {
          const leftCols = j.left_alias && aliasMap[j.left_alias]
            ? (columnCache[aliasMap[j.left_alias]] || []) : [];
          const rightCols = j.table ? (columnCache[j.table] || []) : [];
          return (
            <div key={idx} style={S.joinRow}>
              <select
                style={S.select}
                value={j.join_type || 'left'}
                onChange={(e) => updateJoin(idx, { join_type: e.target.value })}
              >
                <option value="left">LEFT JOIN</option>
                <option value="inner">INNER JOIN</option>
              </select>

              <select
                style={S.select}
                value={j.table || ''}
                onChange={(e) => updateJoin(idx, { table: e.target.value, alias: '', right_field: '' })}
              >
                <option value="">Select table…</option>
                <optgroup label="Standard">
                  {standardTables.map((t) => <option key={t} value={t}>{t}</option>)}
                </optgroup>
                <optgroup label="Custom">
                  {customTables.map((t) => <option key={t.table_name} value={t.table_name}>{t.display_name}</option>)}
                </optgroup>
              </select>

              <input
                type="text"
                style={S.input}
                placeholder="alias"
                value={j.alias || ''}
                onChange={(e) => updateJoin(idx, { alias: e.target.value.replace(/[^a-zA-Z0-9_]/g, '') })}
              />

              <select
                style={S.select}
                value={`${j.left_alias || ''}.${j.left_field || ''}`}
                onChange={(e) => {
                  const [a, f] = e.target.value.split('.');
                  updateJoin(idx, { left_alias: a, left_field: f });
                }}
              >
                <option value=".">Left side: alias.field…</option>
                {Object.entries(aliasMap).filter(([a]) => a !== j.alias).map(([a, t]) => {
                  const cols = columnCache[t] || [];
                  return (
                    <optgroup key={a} label={`${a} (${t})`}>
                      {cols.map((c) => (
                        <option key={`${a}.${c.name}`} value={`${a}.${c.name}`}>{a}.{c.name}</option>
                      ))}
                    </optgroup>
                  );
                })}
              </select>

              <span style={S.joinLabel}>=</span>

              <select
                style={S.select}
                value={j.right_field || ''}
                onChange={(e) => updateJoin(idx, { right_field: e.target.value })}
                disabled={!j.table}
              >
                <option value="">Right field…</option>
                {rightCols.map((c) => (
                  <option key={c.name} value={c.name}>{(j.alias || '?') + '.' + c.name}</option>
                ))}
              </select>

              <button style={S.removeJoinBtn} onClick={() => removeJoin(idx)} title="Remove join">×</button>
            </div>
          );
        })}
        <button style={S.addJoinBtn} onClick={addJoin} disabled={!primaryTable}>+ Add Join</button>
      </div>

      {/* ── Preview ─────────────────────────────────────────── */}
      {preview && (
        <div style={S.previewCard}>
          <div style={S.previewHeader}>
            Preview — {preview.columns.length} columns, {preview.sample_rows.length} sample row{preview.sample_rows.length === 1 ? '' : 's'}
          </div>
          <div style={{ overflow: 'auto' }}>
            <table style={S.previewTable}>
              <thead>
                <tr>{preview.columns.slice(0, 12).map((c) => (
                  <th key={c.name} style={S.previewTh} title={`${c.source_alias}.${c.source_field} (${c.type})`}>
                    {c.label}
                  </th>
                ))}</tr>
              </thead>
              <tbody>
                {preview.sample_rows.map((row, i) => (
                  <tr key={i}>{preview.columns.slice(0, 12).map((c) => (
                    <td key={c.name} style={S.previewTd}>
                      {row[c.name] === null || row[c.name] === undefined ? '' : String(row[c.name])}
                    </td>
                  ))}</tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ── Saved sources ──────────────────────────────────── */}
      <div style={{ ...S.card, marginTop: 18 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
          <h3 style={{ margin: 0, fontSize: 14, color: '#E2E8F0' }}>Saved Joined Sources</h3>
          <span style={{ fontSize: 12, color: '#64748B' }}>
            {savedSources.length} source{savedSources.length === 1 ? '' : 's'}
          </span>
        </div>
        <div style={S.savedHeader}>
          <span>Name</span>
          <span>Description</span>
          <span>Tables</span>
          <span style={{ textAlign: 'right' }}>Actions</span>
        </div>
        {savedSources.length === 0 ? (
          <div style={{ padding: 16, color: '#64748B', fontSize: 12, textAlign: 'center' }}>
            No joined sources yet. Build one above and click Save.
          </div>
        ) : savedSources.map((s) => (
          <div key={s.id} style={S.savedRow}>
            <div>
              <div style={{ fontWeight: 700, color: '#E2E8F0' }}>{s.name}</div>
            </div>
            <div style={{ color: '#94A3B8', fontSize: 12 }}>{s.description || '—'}</div>
            <code style={{ color: '#94A3B8', fontSize: 11 }}>
              {[s.definition.primary_table].concat((s.definition.joins || []).map((j) => j.table)).join(' + ')}
            </code>
            <div style={{ textAlign: 'right' }}>
              <button style={S.iconBtn} onClick={() => onLoad(s)}>Edit</button>
              <button style={{ ...S.iconBtn, color: '#FCA5A5' }} onClick={() => onDelete(s)}>Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
